import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Api } from "src/core/services/api.services";
import BcLoading from "src/shared/components/Bc-Loading/Bc-Loading";
import SwitchFields from "src/shared/components/Bc-SwitchFields/Bc-SwitchFields";
import { FormBase } from "src/shared/interface/form-base";
import { FormDynamic } from "src/shared/interface/form-dynamic";
import LayoutMain from "src/shared/layouts/LayoutMain/LayoutMain";
import { BCButton, ContainerReko } from "src/shared/styled/global.styled";

const FormPrimary: FormDynamic = {
  id: "master",
  name: "Formulario Rekognition",
  user: "masteradmin@bancolombia.com.co",
  fields: [
    {
      label: "Arrastra las fotos para analizar en lote",
      item: "files",
      type: "file",
      isRequired: true,
      placeholder: "Agregar archivo",
    },
    {
      label: "Nombre del directorio de guardado de imagenes",
      item: "path",
      type: "text",
      isRequired: true,
      placeholder:
        "Ingresa el nombre de la carpeta donde se guardaran las imagenes",
    },
  ],
  version: 1,
  dateCreate: new Date().toDateString(),
  dateEdit: new Date().toDateString(),
};

const RekognitionLote = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjError, setMsjError] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataPhoto, setDataPhoto] = useState<any>(null);
  const [form, setForm] = useState<FormDynamic>();
  const [fileCsv, setFileCsv] = useState("");

  useEffect(() => {
    setForm(FormPrimary);
  }, []);

  const {
    register,
    unregister,
    setValue,
    handleSubmit,
    getValues,
    watch,
    resetField,
    formState: { isValid },
  } = useForm<any>({ mode: "onChange" });
  const onSubmit = handleSubmit((data: any) => {
    console.log("datos del formulaio --->", data);
    handleFileSelect(data);
    setLoading(true);
    Api.sendPhotoLote(data.files, data.path)
      .then((r: any) => {
        setSuccess(true);
        setDataPhoto(r);
        console.log(dataPhoto);
        setFileCsv(r.csvUrl);
        resetField("files");
        resetField("path");
        setSelectedFile(null);
        setLoading(false);
      })
      .catch((error) => {
        console.log("entro al error");
        initState(error);
      });
  });

  const initState = (error: any) => {
    setSuccess(false);
    setError(true);
    setMsjError(error);
    resetField("file");
    setSelectedFile(null);
    setLoading(false);
    setFileCsv("");
  }

  const handleFileSelect = (data: any) => {
    setSelectedFile(data.files);
    console.log(selectedFile);
  };

  return (
    <LayoutMain idPage="RekognitionLote" titlePage={true}>
      <form onSubmit={onSubmit} className="bc-container">
        {form?.fields &&
          form.fields.map((field: FormBase) => (
            <SwitchFields
              key={`master${field.item}`}
              field={field}
              register={register}
              unregister={unregister}
              setValue={setValue}
              isRequired={field.isRequired}
              getValues={getValues}
              watch={watch}
              resetField={resetField}
              multiFile={true}
            />
          ))}
        <BCButton
          type="submit"
          className="bc-button-primary bc-button-small"
          disabled={!isValid || loading}
        >
          Enviar
        </BCButton>
      </form>
      {loading && <BcLoading messages={"Analizando las imagenes..."} />}
      {success && !loading && (
        <ContainerReko className="bc-container center-data lote-data">
          <h2>Las imagenes fueron analizadas con exito</h2>
          {fileCsv && (
            <a
              href={fileCsv}
              className="bc-button-primary bc-button-small"
              target="_blank"
              rel="noopener noreferrer"
            >
              Descargar archivo CSV
            </a>
          )}
          <p>No se presentaron errores en la carga.</p>
        </ContainerReko>
      )}
      {error && !loading && (
        <ContainerReko className="bc-container center-data lote-data">
          <h2>No fue posible analizar las imagenes</h2>
          <p>Mensaje:{msjError} </p>
          <p>Vuelve a intentar la carga de las imagenes</p>
        </ContainerReko>
      )}
    </LayoutMain>
  );
};

export default RekognitionLote;
